import React, { PureComponent } from 'react';

class CustomInputText extends PureComponent {

    componentDidMount(){

        const { field, form: { setFieldTouched }  } = this.props;

        if(field.value !== ""){
            setFieldTouched(field.name, true);
            document.querySelector(`input[name="${field.name}"]`).parentElement.parentElement.classList.add('hovered');
        }
    }

    handleBlur = e => {
        const {
            field: { /*name,*/ onBlur }, callback
        } = this.props;
     

        onBlur(e);
        
        // The latest touched and errors aren't available until after the
        // formik's onBlur handler has been called. Setting a timeout allows us
        // to access the proper touched and errors after onBlur event has
        // occurred.
        setTimeout(() => {
            // const {
                // form: { touched, errors },
            // } = this.props;
            // const isError = touched[name] && errors[name];
            // const isSuccess = touched[name] && !errors[name];

            if(e.target.value === "") e.target.parentElement.parentElement.classList.remove('hovered'); 
            
            if(callback) callback();
            
            /*if (isError) {
                console.log('validation error');
            }

            if (isSuccess) {
                console.log('validation success');
            }*/
        }, 0);
    };

    handleFocus = e => {
        e.target.parentElement.parentElement.classList.add('hovered');
    }


    render() {
        const { field, form: { touched, errors }, placeHolderText, isRequired, clazz, type } = this.props;

        const _isEmpty = (clazz === '') ? '' : '';
        const _hasPb2 = (clazz === 'pb2') ? 'pb2' : 'pb2';
        const _isRequired = isRequired ? ((errors[field.name] && touched[field.name]) ? 'pb1' : `${_isEmpty}${_hasPb2}`) : `${_isEmpty}${_hasPb2}`; 
            
        return (
            <div className={_isRequired}>
                <div className={`material-input `}>
                    <label htmlFor={field.name}>
                    <span>{placeHolderText}</span>
                        <input
                            className={`input-control ${(errors[field.name] && touched[field.name]) ? "error" : ""}`}
                            type={type}
                            {...field}
                            onFocus={this.handleFocus} 
                            onBlur={this.handleBlur}
                            autoCorrect="off"
                            autoComplete="off"
                        />
                    </label> 
                </div>
            </div>
        );


    }
}

export default CustomInputText;

